import { FileUp } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FileUpIcon = createLucideIcon(FileUp);
